import { Theme, css } from '@emotion/react';

export const layoutContainer = ({ breakpoints, spacing }: Theme) => css`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing(3)}px;

  ${breakpoints.up('sm')} {
    align-items: center;
    grid-template-columns: 1fr minmax(auto, 300px);
  }
`;

export const actionsContainer = ({ breakpoints, spacing }: Theme) => css`
  align-items: center;
  display: flex;
  gap: ${spacing(1)}px;

  ${breakpoints.up('sm')} {
    a:first-of-type {
      flex: 1;
    }
  }
`;

export const headingWithAdornment = ({ spacing }: Theme) => css`
  align-items: center;
  display: flex;
  gap: ${spacing(1)}px;
`;

export const submittedContainer = ({ spacing }: Theme) => css`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: ${spacing(1)}px;
`;

export const successIcon = ({ colors }: Theme) => css`
  color: ${colors.fgSuccessBase};
`;
